import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface RuleSelectOption {
    value: string;
    label: string;
}

interface RuleSelectProps {
    label: string;
    value: string;
    options: RuleSelectOption[];
    disabled?: boolean;
    onChange: (value: string) => void;
}

const fontSizeSx = { fontSize: { xs: '0.78rem', sm: '0.875rem' } };

const selectSx = {
    ...fontSizeSx,
    '& .MuiSelect-select': { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
};

const menuProps = { PaperProps: { style: { maxHeight: 300 } } };

const measureWidth = (labels: string[]): string =>
    `min(${Math.max(4, ...labels.map(label => label.length)) + 4}ch, clamp(110px, 34vw, 260px))`;

function RuleSelect({ label, value, options, disabled, onChange }: RuleSelectProps) {
    return (
        <FormControl size="small" sx={{ width: measureWidth(options.map(option => option.label)), maxWidth: '100%', flexShrink: 1 }}>
            <InputLabel sx={fontSizeSx}>{label}</InputLabel>
            <Select
                value={value}
                label={label}
                onChange={event => onChange(event.target.value)}
                disabled={disabled}
                sx={selectSx}
                MenuProps={menuProps}
            >
                {options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default RuleSelect;
